module.exports = __webpack_public_path__ + "img/una.8cdb609a.svg";